import { EventSales as GQLItem } from '../generated/graphql';

export type EventSales = {
  totalTicketsSalesToday: number;
  totalTicketsSoldToday: number;
  totalTicketsSales: number;
  totalTicketsSold: number;
  totalTicketsAvailable: number;
  totalTickets: number;
  totalTicketsOnHold: number;
  totalSalesLimit: number;
};

export const getNew = (): EventSales => ({
  totalTicketsSalesToday: 0,
  totalTicketsSoldToday: 0,
  totalTicketsSales: 0,
  totalTicketsSold: 0,
  totalTicketsAvailable: 0,
  totalTickets: 0,
  totalTicketsOnHold: 0,
  totalSalesLimit: 0,
});

export const fromGql = (item: GQLItem): EventSales => ({
  totalTicketsSalesToday: item.totalTicketsSalesToday ?? 0,
  totalTicketsSoldToday: item.totalTicketsSoldToday ?? 0,
  totalTicketsSales: item.totalTicketsSales ?? 0,
  totalTicketsSold: item.totalTicketsSold ?? 0,
  totalTicketsAvailable: item.totalTicketsAvailable ?? 0,
  totalTickets: item.totalTickets ?? 0,
  totalTicketsOnHold: item.totalTicketsOnHold ?? 0,
  totalSalesLimit: item.totalSalesLimit ?? 0,
});

export const fromGqlCollection = (items: GQLItem[]): EventSales[] => items.map(fromGql);
